var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isInitialized)?_c('router-view',{attrs:{"loading":_vm.loading,"images":_vm.images,"meta":_vm.meta},on:{"image:search":_vm.onSearch,"image:pagination":_vm.onPagination}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }